import VueI18n from "vue-i18n";
import Vue from "vue";
import arabic from "../translations/ar.json";
import english from "../translations/en.json";
import french from "../translations/fr.json";
import german from "../translations/de.json";
import spanish from "../translations/es.json";
import hindi from "../translations/hi.json";
import indonesian from "../translations/in.json";
import italian from "../translations/it.json";
import polish from "../translations/pl.json";
import portuguese from "../translations/pt.json";
import russian from "../translations/ru.json";
import tamil from "../translations/ta.json";
import turkey from "../translations/tr.json";
import bengali from "../translations/bn.json";
import gujrati from "../translations/gu.json";
import hebrew from "../translations/he.json";
import japanese from "../translations/ja.json";
import kannada from "../translations/kn.json";
import korean from "../translations/ko.json";
import malayalam from "../translations/ml.json";
import punjabi from "../translations/pa.json";
import telugu from "../translations/te.json";
import thai from "../translations/th.json";
import vietnamese from "../translations/vi.json";
import chinese from "../translations/zh.json";

Vue.use(VueI18n);

// Ready translated locale translations
export const translations = {
  "en-US": english,
  "en-IN": english,
  fr: french,
  "ar-u-nu-arab": arabic,
  de: german,
  es: spanish,
  hi: hindi,
  in: indonesian,
  it: italian,
  pl: polish,
  pt: portuguese,
  ru: russian,
  ta: tamil,
  tr: turkey,
  bn: bengali,
  gu: gujrati,
  he: hebrew,
  ja: japanese,
  kn: kannada,
  ko: korean,
  ml: malayalam,
  pa: punjabi,
  te: telugu,
  th: thai,
  vi: vietnamese,
  zh: chinese,
};
// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: localStorage.getItem('language'), // set locale
  fallbackLocale: "en-US",
  messages: translations, // set locale translations
});

export default i18n;
